import { render, staticRenderFns } from "./configMarginGroup.vue?vue&type=template&id=32399873&scoped=true"
import script from "./configMarginGroup.vue?vue&type=script&lang=js"
export * from "./configMarginGroup.vue?vue&type=script&lang=js"
import style0 from "./configMarginGroup.vue?vue&type=style&index=0&id=32399873&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32399873",
  null
  
)

export default component.exports